import { Reveal } from "@/components/site/Reveal";

const CLIENTS = [
  { name: "Enclave", tag: "Luxury Residential Community" },
  { name: "Serene Living", tag: "Holiday Homes" },
  { name: "L.I.V Developers", tag: "Property Development" },
  { name: "Lemon Homes", tag: "Holiday Home Operator" },
  { name: "Falcon Stay", tag: "Serviced Apartments" },
];

export const TrustedBy = () => {
  return (
    <section
      data-testid="trusted-by"
      className="py-16 lg:py-20 bg-white border-y border-black/5"
    >
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
        <Reveal>
          <div className="text-center">
            <span className="text-[11px] uppercase tracking-[0.28em] text-[#707070] font-medium">
              Trusted by Dubai's Leading Operators
            </span>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-8 lg:gap-x-16">
            {CLIENTS.map((c) => (
              <div
                key={c.name}
                data-testid={`client-logo-${c.name.toLowerCase().replace(/\W+/g, "-")}`}
                className="group flex flex-col items-center opacity-60 hover:opacity-100 transition-opacity duration-500 cursor-default"
              >
                <div className="font-display text-2xl md:text-[26px] font-extrabold text-[#13294B] tracking-tight">
                  {c.name}
                </div>
                <div className="mt-1 text-[10px] uppercase tracking-[0.2em] text-[#707070]">
                  {c.tag}
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
